export function isArtemEarthEmail(
  email: string | null | undefined
): boolean {
  if (email == null) {
    return false
  }
  return email.toLowerCase().endsWith('@artem.earth')
}
